import React from "react";
import {
  Box,
  Typography,
  Stack,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  Avatar,
} from "@mui/material";

import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import EventRoundedIcon from "@mui/icons-material/EventRounded";
import ConfirmationNumberRoundedIcon from "@mui/icons-material/ConfirmationNumberRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import QrCodeScannerRoundedIcon from "@mui/icons-material/QrCodeScannerRounded";

function normalizePath(p = "") {
  if (p.length > 1 && p.endsWith("/")) return p.slice(0, -1);
  return p;
}

function isActivePath(pathname, to) {
  const p = normalizePath(pathname);
  const t = normalizePath(to);

  if (t === "/dashboard") return p === "/dashboard";
  return p === t || p.startsWith(t + "/");
}

export const DASHBOARD_DRAWER_WIDTH = 280;

export default function DashboardSidebar({ pathname, onGo, onGoCheckin }) {
  const navItems = [
    { label: "Visão geral", icon: <DashboardRoundedIcon />, to: "/dashboard" },
    { label: "Eventos", icon: <EventRoundedIcon />, to: "/dashboard/eventos" },
    {
      label: "Vendas",
      icon: <ConfirmationNumberRoundedIcon />,
      to: "/dashboard/vendas",
    },
    { label: "Check-in", icon: <QrCodeScannerRoundedIcon />, to: "/dashboard/checkin" },
    {
      label: "Relatórios",
      icon: <BarChartRoundedIcon />,
      to: "/dashboard/relatorios",
    },
    {
      label: "Configurações",
      icon: <SettingsRoundedIcon />,
      to: "/dashboard/configuracoes",
    },
  ];

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        bgcolor: "#060C16",
        color: "rgba(255,255,255,0.86)",
        borderRight: "1px solid rgba(255,255,255,0.10)",
      }}
    >
      {/* Brand */}
      <Box sx={{ p: 2.2 }}>
        <Stack direction="row" spacing={1.2} alignItems="center">
          <Box
            sx={{
              width: 38,
              height: 38,
              borderRadius: "12px",
              background:
                "linear-gradient(135deg, rgba(0,180,255,0.85), rgba(0,255,180,0.75))",
              boxShadow: "0 10px 30px rgba(0,180,255,0.18)",
            }}
          />
          <Box>
            <Typography sx={{ fontWeight: 900, lineHeight: 1 }}>
              ONURB PASS
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.7 }}>
              Painel do Organizador
            </Typography>
          </Box>
        </Stack>
      </Box>

      <Divider sx={{ borderColor: "rgba(255,255,255,0.10)" }} />

      {/* Nav */}
      <List sx={{ px: 1.2, py: 1.2 }}>
        {navItems.map((item) => {
          const active = isActivePath(pathname, item.to);

          return (
            <ListItemButton
              key={item.to}
              onClick={() => onGo(item.to)}
              sx={{
                mb: 0.6,
                borderRadius: "14px",
                color: active
                  ? "rgba(255,255,255,0.95)"
                  : "rgba(255,255,255,0.78)",
                bgcolor: active ? "rgba(0,180,255,0.12)" : "transparent",
                border: active
                  ? "1px solid rgba(0,180,255,0.25)"
                  : "1px solid transparent",
                "&:hover": {
                  bgcolor: active
                    ? "rgba(0,180,255,0.14)"
                    : "rgba(255,255,255,0.05)",
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 42,
                  color: active
                    ? "rgba(140,220,255,0.95)"
                    : "rgba(255,255,255,0.70)",
                }}
              >
                {item.icon}
              </ListItemIcon>

              <ListItemText
                primary={item.label}
                primaryTypographyProps={{ fontWeight: active ? 800 : 600 }}
              />
            </ListItemButton>
          );
        })}
      </List>

      <Box sx={{ px: 2, pb: 2, mt: "auto" }}>
        <Divider sx={{ borderColor: "rgba(255,255,255,0.10)", mb: 2 }} />

        <Stack spacing={1}>
          <Button
            variant="outlined"
            startIcon={<QrCodeScannerRoundedIcon />}
            onClick={() => window.open("/checkin", "_blank")}
            sx={{
              justifyContent: "flex-start",
              borderColor: "rgba(34,197,94,0.35)",
              color: "#4ade80",
              borderRadius: "14px",
              textTransform: "none",
              "&:hover": { borderColor: "rgba(34,197,94,0.6)", background: "rgba(34,197,94,0.06)" },
            }}
          >
            Abrir scanner
          </Button>

          <Stack direction="row" spacing={1.2} alignItems="center">
            <Avatar
              sx={{ width: 34, height: 34, bgcolor: "rgba(255,255,255,0.10)" }}
            >
              O
            </Avatar>
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{ fontWeight: 800, fontSize: 13, lineHeight: 1.1 }}
                noWrap
              >
                Organizador
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.7 }} noWrap>
                conta@organizador.com
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
}
